<template>
  <v-container>
    <template v-if="false">
      <div id="printArea">
        <div class="flexBox">
          <div class="flexCont1">
            <p class="caption text-uppercase"></p>
          </div>
          <div class="flexCont2">
            <v-img aspect-ratio="2" contain :src="CompanyLogo" />
            <span>{{ company.comapy }}</span>
          </div>
          <div class="flexCont3">
            <p class="caption text-uppercase">
              Ph: {{ company.phone1 }}
              {{ company.phone2 == null ? "" : "/" + company.phone2 }}
            </p>
            <p class="caption">{{ company.webpage }}</p>
          </div>
        </div>
        <div class="flexBox">
          <div class="flexCont1">
            <span class="caption">Name:</span>
            <span class="caption text-left">{{ customerName }}</span>
          </div>
          <div class="flexCont1">
            <span class="caption">Ph:</span>
            <span class="caption text-left">{{ customerPhone }}</span>
          </div>
        </div>
        <div>
          <table
            style="
              width: 100%;
              height: 100%;
              border-bottom: 1px solid black;
              border-top: 1px solid black;
            "
          >
            <tr>
              <td class="text-center" style="border-right: 1px solid black">
                ITEM NAME
              </td>
              <td class="text-center" style="border-right: 1px solid black">
                ₹/Per
              </td>
              <td class="text-center" style="border-right: 1px solid black">
                Qty
              </td>
              <td class="text-center">Total</td>
            </tr>
            <tr v-for="(i, index) in items" :key="index">
              <td
                style="
                  border-right: 1px solid black;
                  border-top: 1px solid black;
                "
              >
                {{ i.name }}
              </td>
              <td
                style="
                  border-right: 1px solid black;
                  border-top: 1px solid black;
                "
              >
                {{ i.mrp }}
              </td>
              <td
                style="
                  border-right: 1px solid black;
                  border-top: 1px solid black;
                "
              >
                {{ i.qty }}
              </td>
              <td style="border-top: 1px solid black">{{ i.total | rupee }}</td>
            </tr>
          </table>
          <br />
          <v-row>
            <v-col>
              <p>TOTAL</p>
            </v-col>
            <v-col class="text-right">
              <p>
                <b>{{ grandTotal | rupee }}</b>
              </p>
            </v-col>
          </v-row>
        </div>
      </div>
    </template>
    <div class="delA">
      <v-btn block dark @click="print">PRINT</v-btn>
      <br />
    </div>
    <template v-if="PRINT_BILLS != undefined">
      <div class="outerLayer">
        <div class="header">
          <div class="row">
            <div class="col pl-5">
              <p>
                <b>JET WINGS</b>
              </p>
              <!--<p class="text-left">4/107 A SECTOR V.G RAO NAGAR, KATPADI VELLORE -632007</p>-->
              <p></p>
              <p class="text-left">
                No: 34/19-A, 4th East Cross Road, Gandhi Nagar, Vellore, Tamil
                Nadu 632006
              </p>
              <p>
                <b>PH:9843555525</b>
              </p>
              <!--<p>
                <b>GSTIN:</b>
              </p>-->

              <p>www.jetwings.in</p>
              <p class="overline font-weight-bold text-decoration-underline">
                *GST Exemption
              </p>
            </div>
            <div class="col text-center">
              <p>
                <b>INVOICE</b>
                <br />
                <img :src="CompanyLogo" alt width="80" height="80" />
              </p>
            </div>
            <div class="col">
              <p>TO:</p>
              <template v-if="custData.cust == 'CUSTOMER'">
                <div class="pl-5">
                  <p>
                    <b>{{ custData.name }}</b>
                  </p>
                  <p>{{ custData.phone }}</p>
                  <!-- <p>GSTIN:33AEEFS3349N1ZO</p> -->
                </div>
              </template>
              <template v-else-if="custData.cust == 'SWIGGY'">
                <div class="pl-5">
                  <p>
                    <b>SWIGGY</b>
                  </p>
                  <p>
                    Order Id :
                    <b>{{ custData.phone }}</b>
                  </p>
                </div>
              </template>
              <template v-else-if="custData.cust == 'CASH'">
                <p class="text-uppercase">
                  <b>CASH</b>
                </p>
              </template>
              <template v-else>
                <div class="pl-5">
                  <p class="text-uppercase">
                    <b>{{ custData.cust }}</b>
                  </p>
                  <p>
                    <b>{{ custData.name }}</b>
                  </p>
                  <p>Ph: {{ custData.phone }}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="tableData">
          <div class="tableData__header">
            <div class="row text-center">
              <div class="col">
                <b>INVOICE NO : {{ custData.id }}</b>
              </div>
              <div class="col">
                <b>
                  INVOICE DATE:
                  <span class="pl-3">{{ custData.timestamp | date }}</span>
                </b>
              </div>
            </div>
          </div>
          <div class="tableData__subHeader">
            <table>
              <thead>
                <tr>
                  <th rowspan="2">S.No</th>
                  <th rowspan="2">Product Name</th>
                  <th rowspan="2">M.R.P</th>
                  <th rowspan="2">Qty</th>
                  <th rowspan="2">Rate</th>
                  <!-- <th rowspan="2">Amount</th>
                  <th colspan="2">CGST</th>
                  <th colspan="2">SGST</th>-->
                  <th rowspan="2">TOTAL</th>
                </tr>
                <!-- <tr>
                  <th class="bt">%</th>
                  <th class="bt">Amount</th>
                  <th class="bt">%</th>
                  <th class="bt">Amount</th>
                </tr>-->
              </thead>
              <tbody>
                <tr v-for="(i, index) in items" :key="index">
                  <td width="5%" class="text-center">{{ index + 1 }}</td>
                  <td width="30%">{{ i.name }}</td>
                  <td class="text-right">
                    {{ "₹ " + Number(i.mrp).toFixed(2) }}
                  </td>
                  <td class="text-center">{{ i.qty }}</td>
                  <td class="text-right">
                    {{ "₹ " + Number(i.rate).toFixed(2) }}
                  </td>
                  <td class="text-right">
                    {{ "₹ " + Number(i.amaount).toFixed(2) }}
                  </td>
                </tr>
                <template v-if="items.length < 10">
                  <tr v-for="(i, index) in 10 - items.length" :key="index + 10">
                    <td class="text-center">-</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </template>
                <tr style="border: 1px solid black">
                  <td colspan="2" class="text-center">Total</td>
                  <td class="text-right">
                    <!-- {{ items.length >= 1 ? items : [] | totalMrp }} -->
                  </td>
                  <td class="text-center">
                    {{ items.length >= 1 ? items : [] | totalQty }}
                  </td>
                  <td class="text-right">
                    <!-- {{ items.length >= 1 ? items : [] | totalRate }} -->
                  </td>
                  <td class="text-right">
                    <div class="row">
                      <div class="col pl-3">
                        <span>Sub Total</span>
                      </div>
                      <div class="col text-right pr-3">
                        {{ items.length >= 1 ? items : [] | subTotal | rupee }}
                      </div>
                    </div>
                    <!-- {{ items.length >= 1 ? items : [] | subTotal }} -->
                  </td>
                </tr>
                <tr class="bt">
                  <td colspan="5">
                    <p>
                      {{
                        items.length >= 1
                          ? { custData, items }
                          : null | grandTot | rupeesToWords
                      }}
                    </p>
                  </td>
                  <td colspan="4">
                    <div class="row">
                      <div class="col pl-3">
                        <span>Discount</span>
                      </div>
                      <div class="col text-right pr-3">
                        {{ custData.discount + " %" }}
                      </div>
                    </div>

                    <div class="row">
                      <div class="col pl-3">
                        <span>Grand Total</span>
                      </div>
                      <div class="col text-right pr-3">
                        <b>{{
                          items.length >= 1
                            ? { custData, items }
                            : null | grandTot | rupee
                        }}</b>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="tableData__footer">
            <div class="row">
              <div class="col-4 pl-5">
                <p>
                  <b>Terms and Conditions</b>
                </p>
                <span
                  >1.Goods once sold will not be taken back or exchanged.</span
                >
                <br />
                <span>2.All Subject to "VELLORE" judisdiction.</span>
              </div>
              <div class="col pt-2 pb-2">
                <div>
                  <b>Our Bank Detials:</b><br />
                  A/C No: <b>168302000000217</b> <br />
                  Bank: <b>Indian Overseas Bank</b>
                  <br />
                  Branch:<b> Auxilium College Vellore </b>
                  <br />
                  IFSC:
                  <b> IOBA0001683 </b>
                  <br />
                </div>
              </div>
              <div class="col">
                <br />
                <br />
                <br />
                <br />
                <b>
                  <p>Customer Signature</p>
                </b>
              </div>
              <div class="col">
                <br />
                <br />
                <br />
                <br />
                <b>
                  <p>Authorised Signature</p>
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </v-container>
</template>

<script>
import CompanyLogo from "../assets/Jet Wings.svg";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      CompanyLogo,
      custData: {},
      customerName: "",
      customerPhone: "",
      company: {},
      items: [],
      grandTotal: 0,
      productStore: {},
      timeStapm: "",
      billNo: 0,
    };
  },
  created() {
    this.company = this.$session.get("company");
    this.$store.commit("SET_LOADING", true);
    this.GET_PRINT_BILL({ id: this.$route.params.id }).then(() => {
      if (this.PRINT_BILLS.items.length >= 1) {
        // console.log(this.PRINT_BILLS);
        this.custData = this.PRINT_BILLS.userData;
        this.items = this.PRINT_BILLS.items;
        this.customerName = this.PRINT_BILLS.userData.name;
        this.customerPhone = this.PRINT_BILLS.userData.phone;
        this.billNo = this.PRINT_BILLS.userData.id;

        // this.timeStapm = this.PRINT_BILLS.userData.timestamp;
        // this.grandTotal = this.PRINT_BILLS.userData.grandtotal;
      }
      this.$store.commit("SET_LOADING", false);
    });
  },
  computed: {
    ...mapGetters(["PRINT_BILLS"]),
  },
  methods: {
    ...mapActions(["GET_PRINT_BILL"]),
    print() {
      window.print();
    },
  },
  filters: {
    subTotal(val) {
      let sum = 0.0;
      if (val.length >= 1) {
        val.forEach((el) => {
          sum = Number(sum) + Number(el.amaount);
        });
      }
      return sum.toFixed(2);
      // return  "₹ " + sum.toFixed(2);
    },
    totalwithgst(val) {
      let sum = 0.0;
      if (val.length >= 1) {
        val.forEach((el) => {
          sum = Number(sum) + Number(el.total);
        });
      }
      return "₹ " + sum.toFixed(2);
    },
    cgst(val) {
      let sum = 0.0;
      if (val.length >= 1) {
        val.forEach((el) => {
          sum = Number(sum) + Number(el.a_cgst);
        });
      }
      return "₹ " + sum.toFixed(2);
    },
    sgst(val) {
      let sum = 0.0;
      if (val.length >= 1) {
        val.forEach((el) => {
          sum = Number(sum) + Number(el.a_sgst);
        });
      }
      return "₹ " + sum.toFixed(2);
    },
    gst(val) {
      let sum = 0.0;
      if (val.length >= 1) {
        val.forEach((el) => {
          sum = Number(sum) + Number(el.a_sgst) + Number(el.a_cgst);
        });
      }
      return "₹ " + sum.toFixed(2);
    },
    grandTot(val) {
      let sum = 0.0;
      if (val != null) {
        if (val.items.length >= 1) {
          val.items.forEach((el) => {
            sum = Number(sum) + Number(el.total);
          });
          if (val.custData.discount >= 1) {
            let discountPrice = Number((sum / 100) * val.custData.discount);
            sum = Number(Number(sum) - discountPrice);
          }
        }
      }
      return Math.round(sum);
    },
    totalQty(val) {
      let sum = 0;
      if (val != null) {
        if (val.length >= 1) {
          val.forEach((el) => {
            sum = Number(sum) + Number(el.qty);
          });
        }
      }
      return sum;
    },
    totalMrp(val) {
      let sum = 0;
      if (val != null) {
        if (val.length >= 1) {
          val.forEach((el) => {
            sum = Number(sum) + Number(el.mrp);
          });
        }
      }
      return "₹ " + sum.toFixed(2);
    },
    totalRate(val) {
      let sum = 0;
      if (val != null) {
        if (val.length >= 1) {
          val.forEach((el) => {
            sum = Number(sum) + Number(el.rate);
          });
        }
      }
      return "₹ " + sum.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.flexBox {
  display: flex;
}
.flexCont1 {
  text-align: left;
  justify-content: start;
  flex: 1;
}
.flexCont2 {
  text-align: center;
  flex: 1;
  justify-content: center;
}
.flexCont3 {
  flex: 1;
  text-align: right;
  justify-content: end;
}

.outerLayer {
  padding: 0;
  margin: 0;
  p {
    padding: 0;
    margin: 0;
  }
  border: 2px solid black;
  width: 100%;
  height: 100%;
  line-height: 1.2;
  font-size: 12px;
  .header {
    border-bottom: 1px solid black;
  }
  .tableData {
    &__header {
      background-color: lightblue;
      border-bottom: 1px solid black;
      width: 100%;
      .col {
        padding: 5px;
      }
    }
    &__subHeader {
      table {
        border-collapse: collapse;
        width: 100%;
        th,
        td,
        thead,
        tr {
          border-right: 1px solid black;
          border-left: 1px solid black;
        }
        thead {
          border-bottom: 1px solid black;
        }
        td {
          padding: 1px 5px;
        }
      }
      .row > .col {
        padding: 0;
      }
    }
    &__footer {
      li {
        font-size: 12px;
      }
      border-top: 1px solid black;
      background-color: lightblue;
      .row > .col,
      .row > .col-6 {
        padding: 0;
      }
    }
  }
  .bt {
    border-top: 1px solid black;
  }
}
</style>

